import {
  ARM_PROMPT,
  SHOW_BASIC_NOT,
  SHOW_COLORED_NOT,
  SHOW_FULL_WIDTH_NOT,
  SHOW_IMAGE_NOT,
  SHOW_PROMPT,
  DECREASE_SHOW_FULL_WIDTH_NOT,
  SAT_ALERT

} from '../actions/notificationsActions';

const defaultPrompt = {
  title: 'Def cont',
  message: 'Def cont',
  hooks: {
    onCancel: () => {},
    onClose: () => {},
    onOk: () => {}

  } // END hooks

} // END defaultPrompt

const initialState = {
  last          : null,
  normal        : null,
  bar           : null,
  image         : null,
  promptVisible : false,
  prompt        : defaultPrompt,
  basic         : null,
  alert         : null,
  countAlert    : 0

} // END initialState


export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case SHOW_PROMPT:
    newState = { promptVisible: payload };
    return { ...state, ...newState };

    case ARM_PROMPT:
      let promptObj = {};
      Object.assign(promptObj, defaultPrompt, payload);
      newState = { prompt: promptObj };
      return { ...state, ...newState };

    case SHOW_BASIC_NOT:
      newState = { normal: payload, last: payload };
      return { ...state, ...newState };

    case SHOW_COLORED_NOT:
      newState = { bar: payload, last: payload };
      return { ...state, ...newState };

    case SHOW_FULL_WIDTH_NOT:
      newState = { alert: payload, last: payload, countAlert: ++state.countAlert};
      return { ...state, ...newState };

    case DECREASE_SHOW_FULL_WIDTH_NOT:
      newState = { countAlert: --state.countAlert};
      return { ...state, ...newState };

    case SAT_ALERT:
      newState = { satAlertActive : payload };
      return { ...state, ...newState }

    case SHOW_IMAGE_NOT:
      newState = { basic: payload, last: payload };
      return { ...state, ...newState };

    default:
      return state;

  }

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/notificationsReducer.js